import { Component } from 'san';
import * as _ from 'lodash';

import { IAttachment, IUploaderErrorResponse } from 'src/models';

import toasterService from 'src/services/toaster.service';
import uploaderService from 'src/services/uploader.service';

export default class Attachment extends Component {
    constructor(options: any) {
        super(options);
    }

    static components = {
    }

    initData(): {
        editEnable: boolean;    // {{}}
        items: IAttachment[];   // {==}
        isEditingAttachmentIndex: number;
    } {
        return {
            editEnable: undefined,
            items: [],
            isEditingAttachmentIndex: -1
        };
    }

    attached() {
        this.initUploader();
        document.addEventListener('click', (event) => {
          const input = document.querySelector('.attachment-input'); // attachment input
          const editButton = document.querySelector('.btn-edit'); // 编辑 button
          if (
              !(input && (event.target as Node).isEqualNode(input)) &&
              !(editButton && (event.target as Node).isEqualNode(editButton))
          ) {
            this.updateAttachmentName(); // 移除 Input 输入框
          }
      });
    }

    // 初始化文件上传
    initUploader() {
        uploaderService.show({
            isMultiple: true,
            selector: '#projectAttachmentUploader',
            server: '/api/files/upload',
            // successCallback: (attachment) => {
            //     attachment = _.pick(attachment, 'name', 'url_path');
            //     this.data.push('items', attachment);
            //     toasterService.show({ type: 'success', title: '上传成功' });
            //     this.data.set('isDirty', true);
            // },
            errorCallback: (response: IUploaderErrorResponse) => {
                toasterService.show({
                    type: 'danger',
                    title: response.message,
                    contents: [response.errors && response.errors.join('')]
                });
            },
            finishedCallback: (attachments) => {
                if (!attachments.length) {
                    return;
                }
                attachments = _.map(attachments, attachment => _.pick(attachment, 'name', 'url_path'));
                const dataKey = 'items';
                const oldAttachments = this.data.get(dataKey);
                attachments = _.concat(oldAttachments, attachments);
                this.data.splice(dataKey, [0, oldAttachments.length, ...attachments]);
                toasterService.show({ type: 'success', title: '上传成功' });
                this.data.set('isDirty', true);
            }
        });
    }

    deleteAttachment(attachment: IAttachment) {
        const dataKey = 'items';
        const attachments = this.data.get(dataKey);
        const index = _.findIndex(attachments, { url_path: attachment.url_path });
        this.data.removeAt(dataKey, index);
        this.data.set('isDirty', true);
    }

    getDownloadAttachmentHref(attachment: IAttachment): string {
        return `${attachment.url_path}?downloadName=${encodeURIComponent(attachment.name)}`;
    }

    getBatchDownloadAttachmentsHref(): string {
        const auditId = this.data.get('auditId');
        return `/api/files/archive/workflow/${auditId}?name=${encodeURIComponent('附件')}`
    }

    editAttachment(index: number) {
        this.data.set('isEditingAttachmentIndex', index);
    }

    updateAttachmentName() {
        this.data.set('isEditingAttachmentIndex', -1); // 移除 Input 输入框
    }

    handleKeyup(event) {
      if (event.key === 'Enter' && !event.shiftKey) {
        this.updateAttachmentName();
      }
      if (event.key === 'Escape') {
        this.data.set('isEditingAttachmentIndex', -1); // 移除 Input 输入框
      }
    }

}